import React from 'react';

export default function AdultFaceIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25">
      <g fillRule="evenodd">
        <ellipse
          cx="11.25"
          cy="11.667"
          fillOpacity=".1"
          rx="10.417"
          ry="10.833"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          fillRule="nonzero"
          d="M9.186 11.655c0 .905-.698 1.63-1.57 1.63-.872 0-1.511-.785-1.511-1.63 0-.846.697-1.63 1.57-1.63.872 0 1.511.724 1.511 1.63zm6.28-1.691c-.873 0-1.57.724-1.57 1.63 0 .906.697 1.63 1.57 1.63.871 0 1.569-.724 1.569-1.63 0-.906-.756-1.63-1.57-1.63zm-7.443 6.944c.058.121 1.28 2.838 3.489 2.838 1.511 0 2.848-1.449 3.604-2.838H8.023zM25 12.5C25 19.384 19.419 25 12.5 25S0 19.384 0 12.5 5.64 0 12.5 0 25 5.616 25 12.5zm-1.395 1.147c-2.907-.302-4.593-8.091-4.593-8.091l-.756.664c-1.221 1.328-2.151.543-2.675-.483l-.348-.725-.582.845c-1.163 1.752-2.732.484-3.14-.724l-.232-.483-1.337 1.328c-1.337 1.63-2.5.544-2.849-.785l-.058-.302S5.814 6.401 4.709 7.61c-.697.785-1.918.905-2.616.845-.465 1.268-.756 2.597-.756 4.046 0 6.099 5 11.05 11.163 11.05 5.756 0 10.465-4.347 11.105-9.903z"
        />
      </g>
    </svg>
  );
}
